import * as ACTIONS from "./types"

export const nextPage = () => ({
  type: ACTIONS.FLAG_NEXT_PAGE
})

export const jumpPage = () => ({
  type: ACTIONS.FLAG_JUMP_PAGE
})

export const prevPage = () => ({
  type: ACTIONS.FLAG_PREV_PAGE
})

export const firstPage = () => ({
  type: ACTIONS.FLAG_GOTO_FIRST_PAGE
})

export const submitResults = () => ({
  type: ACTIONS.FLAG_SUBMIT
})

export const clearFlags = () => ({
  type: ACTIONS.UNSET_PAGE_FLAGS
})

export const resetJourney = () => ({
  type: ACTIONS.FLAG_RESET_JOURNEY
})
